    
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { AppConfigService } from '../app-config.service';
import { PublicUtils } from '../../utils/PublicUtils';

@Injectable({
  providedIn: 'root'
})
export class CrmService{
  publicUtils = new PublicUtils();
  enpoint:String = "";
  header:HttpHeaders = new HttpHeaders({
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Accept': 'application/json, text/javascript, */*; q=0.01'
  })
  constructor(private http: HttpClient, private appConfig: AppConfigService){}  

  getPrograms($university){
    let LP = this.appConfig.landing["_value"];
    return this.http.post(`${this.appConfig.config["sever"]}${this.appConfig.config["services"].crm}`, this.getEncodedString({
      service: 1,
      university: $university,
      type: LP["tipo_porgrama"],
      modal: LP["modalidad"],
      typeOpp: LP["tipo_oportunidad"],
      site:LP["sede"],
      progs:LP["programas"],
      filter:LP["categoria"]
    }),{headers:this.header});
  }

  /**
 * sendLead BTL.
    * @param {CSUAgent} - 
    * @param {agentName} - 
    * @param {agentDocument} - 
    * @param {agentMail} - 
    * @param {exploraName} - 
    * @param {exploraDocument} - 
    * @param {exploraMail} - 
    * @param {strategy} - 
    * @param {userName} - 
    * @param {userLastName} - 
    * @param {userDocumentType} - 
    * @param {userDocumentNumber} - 
    * @param {state} - 
    * @param {city} - 
    * @param {schoolName} - 
    * @param {userLastGrade} - 
    * @param {userEmail} - 
    * @param {userMobilePhone} - 
    * @param {userPhone} - 
    * @param {userGenre} - 
    * @param {programType} - 
    * @param {modality} - 
    * @param {site} - 
    * @param {firstInterestProgram} - 
    * @param {secondInterestProgram} - 
    * @param {interestPeriod} - 
    * @param {habeasData} - 
    * @param {address} - 
    * @param {neightborhood} - 
    * @param {province} - 
    * @param {linkedin} - 
    * @param {firstAttendantName} - 
    * @param {firstAttendantMail} - 
    * @param {firstAttendantPhone} - 
    * @param {secondAttendantName} - 
    * @param {secondAttendantMail} - 
    * @param {secondAttendantPhone} - 
    * @param {keyPoint} - 
    * @param {loadPresence} - 
    * @param {servicePresence} - 
    * @param {acceptanceDate} - 
    * @param {twitter} - 
    * @param {facebook} - 
    * @param {countryCode} - 
    * @param {activityOrigin} - 
    * @param {firstInterestArea} - 
    * @param {secondInterestArea} - 
    * @param {universityCode} - 
    * @param {universityChosen} - 
    * @param {originalIndexRow} - 
    * @param {universityMedium} - 
    * @param {agreement} - 
    * @param {company} - 
    * @param {digitalLabDetails} - 
    * @param {GUID} - 
    * @param {registerType} - 
    * @param {contactFormMail} - 
    * @param {contactFormPhone} - 
    * @param {contactFormFax} - 
    * @param {campaignCode} - 
    * @param {opportunityType} - 
    * @param {siteLabel} - 
    * @param {journey} - 
    * @param {academicLevel} - 
    * @param {campaignsValues} - 
    * @param {landingName} - 
    * @param {agreementType} - 
  */
  sendLead($CSUAgent, $agentName, $agentDocument, $agentMail, $exploraName,
    $exploraDocument, $exploraMail, $strategy, $userName, $userLastName, $userDocumentType,
    $userDocumentNumber, $state, $city, $schoolName, $userLastGrade, $userEmail,
    $userMobilePhone, $userPhone, $userGenre, $programType, $modality, $site,
    $firstInterestProgram, $secondInterestProgram, $interestPeriod, $habeasData,
    $address, $neightborhood, $province, $linkedin, $firstAttendantName,
    $firstAttendantMail, $firstAttendantPhone, $secondAttendantName,
    $secondAttendantMail, $secondAttendantPhone, $keyPoint, $loadPresence,
    $servicePresence, $acceptanceDate, $twitter, $facebook, $countryCode,
    $activityOrigin, $firstInterestArea, $secondInterestArea, $universityCode,
    $universityChosen, $originalIndexRow, $universityMedium, $agreement,
    $company, $digitalLabDetails, $GUID, $registerType, $contactFormMail,
    $contactFormPhone, $contactFormFax, $campaignCode, $opportunityType,
    $siteLabel, $journey, $academicLevel, campaignsValues, $landingName, $doNotDisturb){
      return this.http.post(
        `${this.appConfig.config["sever"]}${this.appConfig.config["services"].btl}`, 
        this.getEncodedString({
          service: 4,
          CSUAgent: $CSUAgent,
          agentName: $agentName,
          agentDocument: $agentDocument,
          agentMail: $agentMail,
          exploraName: $exploraName,
          exploraDocument: $exploraDocument,
          exploraMail: $exploraMail,
          strategy: $strategy,
          userName: $userName,
          userLastName: $userLastName,
          userDocumentType: $userDocumentType,
          userDocumentNumber: $userDocumentNumber,
          state: $state,
          city: $city,
          schoolName: $schoolName,
          userLastGrade: $userLastGrade,
          userEmail: $userEmail,
          userMobilePhone: $userMobilePhone,
          userPhone: $userPhone,
          userGenre: $userGenre,
          programType: $programType,
          modality: $modality,
          site: $site,
          firstInterestProgram: $firstInterestProgram,
          secondInterestProgram: $secondInterestProgram,
          interestPeriod: $interestPeriod,
          habeasData: $habeasData,
          address: $address,
          neightborhood: $neightborhood,
          province: $province,
          linkedin: $linkedin,
          firstAttendantName: $firstAttendantName,
          firstAttendantMail: $firstAttendantMail,
          firstAttendantPhone: $firstAttendantPhone,
          secondAttendantName: $secondAttendantName,
          secondAttendantMail: $secondAttendantMail,
          secondAttendantPhone: $secondAttendantPhone,
          keyPoint: $keyPoint,
          loadPresence: $loadPresence,
          servicePresence: $servicePresence,
          acceptanceDate: $acceptanceDate,
          twitter: $twitter,
          facebook: $facebook,
          countryCode: $countryCode,
          activityOrigin: $activityOrigin,
          firstInterestArea: $firstInterestArea,
          secondInterestArea: $secondInterestArea,
          universityCode: $universityCode,
          universityChosen: $universityChosen,
          originalIndexRow: $originalIndexRow,
          universityMedium: $universityMedium,
          agreement: $agreement,
          company: $company,
          digitalLabDetails: $digitalLabDetails,
          GUID: $GUID,
          registerType: $registerType,
          contactFormMail: $contactFormMail,
          contactFormPhone: $contactFormPhone,
          contactFormFax: $contactFormFax,
          campaignCode: $campaignCode,
          opportunityType: $opportunityType,
          siteLabel: $siteLabel,
          journey: $journey,
          academicLevel: $academicLevel,
          landingTerm: campaignsValues.last.cmpid.utm_term,
          landingSource: campaignsValues.last.cmpid.utm_source,
          landingName: $landingName,
          landingMedium: campaignsValues.last.cmpid.utm_medium,
          landingIP: campaignsValues.last.cmpid.utm_campaign,
          landingContent: campaignsValues.last.cmpid.utm_content,
          mediumDetail: campaignsValues.last.cmpid.utm_medium,
          medium: campaignsValues.last.cmpid.utm_source,
          description: campaignsValues.funnel,
          doNotDisturbLaw: $doNotDisturb
      }),
      {headers:this.header}); 
  }

  sendPotencial($CSUAgent, $agentName, $agentDocument, $agentMail, $exploraName,
    $exploraDocument, $exploraMail, $strategy, $userName, $userLastName, $userDocumentType,
    $userDocumentNumber, $state, $city, $schoolName, $userLastGrade, $userEmail,
    $userMobilePhone, $userPhone, $userGenre, $programType, $modality, $site,
    $firstInterestProgram, $secondInterestProgram, $interestPeriod, $habeasData,
    $address, $neightborhood, $province, $linkedin, $firstAttendantName,
    $firstAttendantMail, $firstAttendantPhone, $secondAttendantName,
    $secondAttendantMail, $secondAttendantPhone, $keyPoint, $loadPresence,
    $servicePresence, $acceptanceDate, $twitter, $facebook, $countryCode,
    $activityOrigin, $firstInterestArea, $secondInterestArea, $universityCode,
    $universityChosen, $originalIndexRow, $universityMedium, $agreement,
    $company, $digitalLabDetails, $GUID, $registerType, $contactFormMail,
    $contactFormPhone, $contactFormFax, $campaignCode, $opportunityType,
    $siteLabel, $academicLevel, $journey, $journey2,$interestLevel, $agreementType,campaignsValues, $landingName,
    $doNotDisturb
    ){
    	return this.http.post(
    		`${this.appConfig.config["sever"]}${this.appConfig.config["services"].btl}`, 
    		this.getEncodedString({
                           service: 4,
                            CSUAgent: $CSUAgent,
                            agentName: $agentName,
                            agentDocument: $agentDocument,
                            agentMail: $agentMail,
                            exploraName: $exploraName,
                            exploraDocument: $exploraDocument,
                            exploraMail: $exploraMail,
                            strategy: $strategy,
                            userName: $userName,
                            userLastName: $userLastName,
                            userDocumentType: $userDocumentType,
                            userDocumentNumber: $userDocumentNumber,
                            state: $state,
                            city: $city,
                            schoolName: $schoolName,
                            userLastGrade: $userLastGrade,
                            userEmail: $userEmail,
                            userMobilePhone: $userMobilePhone,
                            userPhone: $userPhone,
                            userGenre: $userGenre,
                            programType: $programType,
                            modality: $modality,
                            site: $site,
                            firstInterestProgram: $firstInterestProgram,
                            secondInterestProgram: $secondInterestProgram,
                            interestPeriod: $interestPeriod,
                            habeasData: $habeasData,
                            address: $address,
                            neightborhood: $neightborhood,
                            province: $province,
                            //linkedin: $linkedin,
                            linkedin: campaignsValues.last.cmpid.utm_content+'-'+campaignsValues.last.cmpid.utm_term,
                            firstAttendantName: $firstAttendantName,
                            firstAttendantMail: $firstAttendantMail,
                            firstAttendantPhone: $firstAttendantPhone,
                            secondAttendantName: $secondAttendantName,
                            secondAttendantMail: $secondAttendantMail,
                            secondAttendantPhone: $secondAttendantPhone,
                            keyPoint: $keyPoint,
                            loadPresence: $loadPresence,
                            servicePresence: $servicePresence,
                            acceptanceDate: $acceptanceDate,
                            //twitter: $twitter,
                            //facebook: $facebook,
                            twitter: campaignsValues.last.cmpid.utm_medium+'-'+campaignsValues.last.cmpid.utm_campaign,
                            facebook: campaignsValues.last.cmpid.utm_source+'-'+$landingName,
                            countryCode: $countryCode,
                            activityOrigin: $activityOrigin,
                            firstInterestArea: $firstInterestArea,
                            secondInterestArea: $secondInterestArea,
                            universityCode: $universityCode,
                            universityChosen: $universityChosen,
                            originalIndexRow: $originalIndexRow,
                            universityMedium: $universityMedium,
                            agreement: $agreement,
                            company: $company,
                            digitalLabDetails: $digitalLabDetails,
                            GUID: $GUID,
                            registerType: $registerType,
                            contactFormMail: $contactFormMail,
                            contactFormPhone: $contactFormPhone,
                            contactFormFax: $contactFormFax,
                            siteLabel: $siteLabel,
                            academicLevel: $academicLevel,
                            journey: $journey,
                            journey2: $journey2,
                            interestLevel: $interestLevel,
                            agreementType: $agreementType,
                            doNotDisturbLaw: $doNotDisturb   		
    		}),
      {headers:this.header}); 
  }

  getDocumentTypes(){
    return this.http.post(`${this.appConfig.config["sever"]}${this.appConfig.config["services"].crm}`, 
    this.getEncodedString({service: 7, country: `${this.appConfig.config["country"]}`}),
    {headers:this.header});
  }
  
  getStates(){
    return this.http.post(`${this.appConfig.config["sever"]}${this.appConfig.config["services"].crm}`, 
    this.getEncodedString({service: 3,country: `${this.appConfig.config["country"]}`}),
    {headers:this.header});    
  }
  
  getCities($state){
    return this.http.post(`${this.appConfig.config["sever"]}${this.appConfig.config["services"].crm}`, 
    this.getEncodedString({service: 4,country: `${this.appConfig.config["country"]}`,state: $state}),
    {headers:this.header});   
  }


  private getEncodedString(params:any){
    let str = '';
    for (let name in params) {
        str += name + '=' + encodeURIComponent(params[name]) + '&'
    }
    let pos = str.length;
    str = str.substring(0, pos - 1) + str.substring(pos, str.length);
    return str;
  }


}
